export default {
    profile: 'ប្រវត្តិរូប',
    invoices: 'វិក្ក័យប័ត្រ',
    logout: 'ថ្ងៃនេះ',
};
